module.exports = __webpack_public_path__ + "static/img/bg-es.96bce594.png";